import React, {useContext} from 'react';
import type {SharedValue} from 'react-native-reanimated';

/**
 * DIS-1840: the scroll signal `AnimatedHeader` hands to `SiteHeader`. `scrollY` is the shared
 * `ScrollCollapseContext.scrollY`; `ready` is that header's local focus gate (0 while shared
 * values settle on focus, 1 after). `StaticHeader` provides nothing, so a static route reads null.
 */
export type HeaderScrollSignal = {scrollY: SharedValue<number>; ready: SharedValue<number>};

export const HeaderCompactContext = React.createContext<HeaderScrollSignal | null>(null);

export const useHeaderScrollSignal = (): HeaderScrollSignal | null =>
  useContext(HeaderCompactContext);
